export default __webpack_public_path__ + "static/media/Display-Settings.b210344d.png";